export default __webpack_public_path__ + "static/media/vip-weekly-bonus.3e166f3b.svg";